<template>
  <v-list>
    <v-list-item @click="itemClicked(currentItem)">
      <i class="pr-1 fa-regular fa-magnifying-glass fa-xl"></i>
      View
    </v-list-item>

    <v-menu
      offset-x
      v-if="canBeDownloaded(currentItem)"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-list-item v-bind="attrs" v-on="on">
          <i class="pr-1 fa-regular fa-download fa-xl"></i>
          Download
        </v-list-item>
      </template>
      <v-list>
        <v-list-item
          v-for="(format, index) in constants.CERTIFICATE_FORMATS"
          :key="index"
          @click="downloadCert({ certid: currentItem.certid, type: format.type, extension: format.extension })"
        >
          <v-list-item-title>
            {{ format.type }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-list-item
      @click="revokeItems([currentItem])"
      v-if="canBeRevoked(currentItem)"
    >
      <div>
        <i class="pr-1 fa-regular fa-circle-minus fa-xl"></i>
        Revoke
      </div>
    </v-list-item>

    <v-list-item
      @click="reinstateItems([currentItem])"
      v-if="canBeReinstated(currentItem)"
    >
      <div>
        <i class="p1-1 fa-solid fa-rotate fa-xl"></i>
        Reinstate
      </div>
    </v-list-item>
  </v-list>
</template>
<script>

import {canBeDownloaded, canBeRevoked, canBeReinstated} from "@/Mixins/certificates/getActionsMixin";
import * as constants from "@/config/constants";

export default {
  props: ["currentItem"],
  mixins: [canBeDownloaded, canBeRevoked, canBeReinstated],
  data() {
    return {};
  },
  computed: {
    constants() {
      return constants
    },
  },
  methods: {
    reinstateItems(value) {
      this.$emit("reinstateButton", value);
    },
    revokeItems(value) {
      this.$emit("revokeButton", value);
    },
    itemClicked(value) {
      this.$emit("itemClicked", value);
    },
    downloadCert(value) {
      this.$emit("downloadCertificateClicked", value);
    },
  },
};
</script>
<style></style>
